module.exports = __webpack_public_path__ + "img/hexagon-01.41b07dcc.svg";